<template>
  <div>
    <report-va :base_info="base_info"></report-va>
  </div>
</template>
<script>
import reportVa from "./ReportVa.vue";

export default {
  name: "reportVerify",
  components: {
    reportVa
  },
  data() {
    return {
      base_info: {
        title_ch: "待审核报告",
        op_title: "审核",
        post_url: "/ask_list_data",
        askData: "reportToVerify",
        opAskData:'verify'
      },
    };
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style scoped>
</style>